<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

// constants
import contentTypes from '@/utils/constants/contentTypes.js';
import axiosResponseTypes from '@/utils/constants/axiosResponseTypes.js';
import subscriptionTypes from '@/utils/constants/subscriptionTypes.js';

// utilities
import utils from '@/utils/utilities.js';

export default {
  name: 'RegistrationSignatureMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
        },
        collections: {
          academicYears: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de Firmas de Registro',
        icon:
          'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Informe de Firmas de Registro'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      const {
        data: currentAcademicYear,
      } = await AcademicYearServices.getCurrentAcademicYear();
      this.model.search.collections.academicYears = [
        {
          id: currentAcademicYear.id,
          name: currentAcademicYear.description,
        },
      ];
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process();
      }
    },
    async process() {
      try {
        const academicYearName = this.model.search.filters.academicYear?.name;
        const fileName = utils.formatString(
          subscriptionTypes.RegistrationSignatures.fileName,
          academicYearName
        );
        const response = await ReportServices.getReportFile(
          'reportfile',
          {
            DirectoryName:
              subscriptionTypes.RegistrationSignatures.directoryName,
            ReportName: fileName,
            FileName: fileName,
            ContentType: contentTypes.excel,
          },
          axiosResponseTypes.blob
        );
        DocumentServices.DownloadFile(response.data, fileName);
      } catch {
        this.ShowToast(
          '',
          'Ha ocurrido un error descargando el reporte.',
          'error'
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
